import { type QueryClient } from '@tanstack/react-query';

import { FetchGetUserLoadService } from '@/packages/query-state/shared/store/monolith-python/cian-api/site/v1/get-user-data-by-request/load';

import { type IFastFiltersUserSchema } from '@/repositories/generated/shared/monolith-python/entities/schemas/FastFiltersUserSchema';

interface IGetAnalyticsUserParams {
  queryClient: QueryClient;
}

export type AnalyticsUser = { userId: number } | {};

export function getAnalyticsUser(params: IGetAnalyticsUserParams): AnalyticsUser {
  const user = getUser(params);

  return user?.isAuthenticated ? { userId: user.userId as number } : {};
}

function getUser({ queryClient }: IGetAnalyticsUserParams): IFastFiltersUserSchema | undefined {
  const userData = new FetchGetUserLoadService(queryClient).getQueryData();

  return userData?.data.user;
}
